import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  message!: any;

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  dismiss(){
    this.modalService.hideSuccessModal();
  }

}
